import * as R from 'ramda';
import moment from 'moment';
import { compareDesc, compareAsc, isBefore } from 'date-fns/fp';

import { modalNames } from '../modals';
import { getCurrentUserId } from './users';
import { USER_ROLES } from '../api/constants';
import { showNotification } from '../components/notification';

/**
 * sortTasksByDueDate :: [Task] -> [Task]
 */
export const sortTasksByDueDate = R.sortWith([
  (a, b) => {
    const left = a.status ? 1 : 0;
    const right = b.status ? 1 : 0;
    return left - right;
  },
  (a, b) => compareDesc(a.dueDate, b.dueDate),
]);

/**
 * sortTasksByPriority :: [Task] -> [Task]
 */
export const sortTasksByPriority = R.sortWith([
  (a, b) => a.priority - b.priority,
]);

/**
 * isTasksOwn :: [Task] -> [Task]
 */
export const isTasksOwn = (tasks = []) => {
  const userId = localStorage.getItem('userId');
  return tasks.every(task => task.assignedTo._id === userId);
};

/**
 * sortTasksByCompletedDate :: [Task] -> [Task]
 */
export const sortTasksByCompletedDate = R.sortWith([
  (a, b) => {
    const left = a.status ? 1 : 0;
    const right = b.status ? 1 : 0;
    return left - right;
  },
  (a, b) => compareAsc(a.completedAt, b.completedAt),
]);

export const isDateExpired = dueDate => isBefore(new Date(), dueDate);

export const disabledDates = currentDate => currentDate < moment().startOf('day');

/**
 * getUndoneTasks :: [Task] -> [Task]
 */
export const getUndoneTasks = R.compose(
  R.sortWith([
    (a, b) => compareDesc(a.dueDate, b.dueDate),
  ]),
  R.filter(item => !item.status),
);

/**
 * getDoneTasks :: [Task] -> [Task]
 */
export const getDoneTasks = R.compose(
  R.sortWith([
    (a, b) => compareAsc(a.completedAt, b.completedAt),
  ]),
  R.filter(item => item.status),
);

export const filteredUsers = (isWithoutRequest, requestAssignees, users) => {
  // Return all users if task is without request
  if (isWithoutRequest) return Object.values(users);
  // Find sales agents assigned to request.
  const requestSales = requestAssignees.filter(user => user.role === USER_ROLES.SALES_AGENT);
  // Form array of all users except sales-agents.
  const filtered = Object.values(users).filter(user => user.role !== USER_ROLES.SALES_AGENT);
  // Return array of users without sales-agents except those who were assigned to request.
  return [...filtered, ...requestSales];
};

// Check if current user is in filtered from Sales Agents users list
export const isCurrentUserAssignable = (isWithoutRequest, requestAssignees, users) =>
  R.contains(getCurrentUserId(), R.pluck('_id', filteredUsers(isWithoutRequest, requestAssignees, users)));


// If Request hasn't 'Undone' Tasks - show notification
export const checkRequestForNextAction = (
  { requestId, requestWithNextAction = true },
  openModal,
) => {
  if (!requestWithNextAction) {
    const key = `next-action-${requestId}`;

    const onClick = () => openModal({
      payload: { requestId },
      name: modalNames.NEXT_ACTION,
    });

    showNotification({
      key,
      onClick,
      duration: 10,
      type: 'warning',
      message: 'Next Action',
      description: 'This Request hasn\'t Undone tasks. To create a new one - click here.',
    });
  }
};



// WEBPACK FOOTER //
// ./src/utils/tasks.js